const NAME = /^[a-z][a-z0-9_]*$/;

export type NewFieldCheck =
  | { state: "bad" | "exists" | "fresh" }
  | { state: "similar"; like: string };

export function searchWord(name: string): string {
  return name.split("_").reduce((a, b) => (b.length > a.length ? b : a), "");
}

export function newFieldCheck(
  path: string,
  name: string,
  found: string[],
  pickedPath: string | null = null,
): NewFieldCheck {
  if (!NAME.test(name)) return { state: "bad" };
  if (found.includes(path)) return { state: "exists" };
  const words = name.split("_").filter((w) => w.length >= 4);
  const like = found.find((p) => {
    if (p === pickedPath) return false;
    const last = p.slice(p.lastIndexOf(".") + 1).split("_");
    return words.filter((w) => last.includes(w)).length >= 2;
  });
  return like ? { state: "similar", like } : { state: "fresh" };
}
